/* eslint-disable max-len */
import React from 'react';
import SplitPane from 'react-split-pane';
import { useLocalStorage } from 'react-use';
import { Redirect } from 'wouter';
import { LFC } from '../../Legacy';
import { ApiClient } from '../../api/ApiClient';
import { Icon } from '../../concepts/resources/Icon';
import { Fill } from '../../ui/Fill';
import { InfoView } from '../../ui/InfoView';
import { LoadingGuard } from '../../ui/LoadingGuard';
import { VerticalTabSet } from '../../ui/VerticalTabSet';
import { UseLocationScope } from '../AppLocation';
import { AppNavigator } from '../AppNavigator';
import { useResolve } from '../Container';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { AccountModel } from '../account/AccountModel';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Crumbs } from '../common/Crumbs';
import { Page } from '../common/Page';
import { Copy, FlexFrame } from '../dashboard/elements/LayoutElements';
import { remInPx } from './../../ui';
import { ManageBillingHistoryView } from './ManageBillingHistoryView';
import { ManageBillingPaymentsView } from './ManageBillingPaymentsView';
import { ManageBillingSettingsView } from './ManageBillingSettingsView';

const { Section, LargeHeading, Heading, DetailTable, DetailRow, DetailCell } = InfoView;
const XSplitPane = SplitPane as any;

const BillingHistoryView = React.memo(() => {

    const api = useResolve(ApiClient);
    const account = useResolve(AccountModel);
    const nav = useResolve(AppNavigator);

    // const [loading, data] = useLoader2(async () => await api.exec(v2.admin.billing.info(account.id)), []);

    return <LoadingGuard loading={false}>
        <Section>
            <LargeHeading>
                Overview
            </LargeHeading>
            <Copy>This is the request archive for your organization.</Copy>
        </Section>
        <Section>
        </Section>
    </LoadingGuard>;
});

const ManageBillingViewLayout: LFC<{ param?: string }> = ({ param }) => {

    const [leftSize, setLeftSize] = useLocalStorage('deqo/ui/billing/leftSize', remInPx(20));

    if (!param) {
        return <Redirect to={'/manage/billing/settings'} />;
    }

    const [mode, ref] = (param || '').split(':');

    return <Fill flex="column">
        <FlexFrame>
            <VerticalTabSet>
                <XSplitPane className="flex" split="vertical" minSize={remInPx(12)} size={leftSize} maxSize={remInPx(30)} onChange={setLeftSize}>
                    <VerticalTabSet.Menu expand>
                        <VerticalTabSet.Link to="~/manage/billing/settings" selected={param?.startsWith('settings')}>
                            <Icon size="1.5" src="deqo://icons/hero/cog" />&nbsp;&nbsp;Settings
                        </VerticalTabSet.Link>
                        <VerticalTabSet.Link to="~/manage/billing/payments" selected={param?.startsWith('payments')}>
                            <Icon size="1.5" src="deqo://icons/hero/cash" />&nbsp;&nbsp;Payments
                        </VerticalTabSet.Link>
                        <VerticalTabSet.Link to="~/manage/billing/history" selected={param?.startsWith('history')}>
                            <Icon size="1.5" src="deqo://icons/hero/archive" />&nbsp;&nbsp;Changes &amp; History
                        </VerticalTabSet.Link>
                    </VerticalTabSet.Menu>
                    <VerticalTabSet.Content>
                        {!ref && mode === 'settings' && <ManageBillingSettingsView />}
                        {!ref && mode === 'payments' && <ManageBillingPaymentsView />}
                        {!ref && mode === 'history' && <ManageBillingHistoryView />}
                    </VerticalTabSet.Content>
                </XSplitPane>
            </VerticalTabSet>
        </FlexFrame>
    </Fill>;
};

export const ManageBillingView: LFC<{ param?: string }> = (props) => {
    return <>
        <UseLocationScope name="billing" label="Billing" />
        <Page.Header>
            <Crumbs items={[
                ['Manage', '/manage'],
                ['Billing', null],
            ]} />
            <Page.HeaderPush>
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Page.HeaderPush>
        </Page.Header>
        <Page.Content>
            <ManageBillingViewLayout {...props} />
        </Page.Content>
    </>;
};

